'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'garage';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e009';
var svgPathData = 'M320 7.4l2.9 1.1 312 120 5.1 2 0 5.5 0 368 0 8-16 0 0-8 0-362.5L320 24.6 16 141.5 16 504l0 8L0 512l0-8L0 136l0-5.5 5.1-2 312-120L320 7.4zM96 192l8 0 432 0 8 0 0 8 0 120 0 16 0 168 0 8-16 0 0-8 0-168-416 0 0 168 0 8-16 0 0-8 0-168 0-16 0-120 0-8zm16 128l416 0 0-112-416 0 0 112zm152 96l112 0 8 0 0 16-8 0-112 0-8 0 0-16 8 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGarage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;